import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { AvatarBackgroundSizes, AvatarShapes } from 'mojo-avatar';

import { CandidateAdapter } from '@shared';

@Component({
  selector: 'mojo-candidate-label',
  templateUrl: './candidate-label.component.html',
  styleUrls: ['./candidate-label.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CandidateLabelComponent {
  @Input() candidate: CandidateAdapter;
  avatarBackground = AvatarBackgroundSizes.cover;
  selectedPhotoShape = AvatarShapes.circle;
}
